<section>
  <form>
    <div class="points">
      @for (point of points(); track point.form) {
        <app-order-point-form
          [point]="point"
          [pointTypes]="pointTypes()"
          [parametersValidation]="parametersValidation()"
          (movePoint)="movePoint($index, $event)"
          (removePoint)="removePoint($index)"
        ></app-order-point-form>
      } @empty {
        <p class="empty f-body-l">{{ `${I18N}.empty` | translate }}</p>
      }
    </div>

    @if (hasRouteEdit()) {
      <div class="bottom-bar">
        <onyx-divider></onyx-divider>

        <div class="toolbar">
          @let options = pointTypesOptions();
          @for (point of options?.buttons; track point.value) {
            @let tooltip = pointsDisabledCategories()[point.category];
            @let disabled = !!tooltip;
            <onyx-button
              variant="outlined"
              [size]="32"
              [disabled]="disabled"
              [onyxTooltip]="`${I18N}.${tooltip}`"
              [onyxTooltipDisabled]="!disabled"
              (click)="!disabled ? addPoint(point) : null"
            >
              <onyx-icon
                [class]="point.color"
                [name]="point.icon"
                [size]="16"
              ></onyx-icon>

              {{ point.name }}
            </onyx-button>
          }

          @if (isDedicated()) {
            <onyx-button
              variant="outlined"
              [size]="32"
              rightIcon="arrow-alt-down-outlined"
              [onyxDropdownOptions]="options?.dropdown"
              (onyxDropdownSelectedValueChange)="$event.value?.()"
            >
              {{ 'labels.more' | translate }}
            </onyx-button>
          }
        </div>
      </div>
    }
  </form>
</section>
